export default {
  getters: {
    canDownloadLogs: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("download_logs")
      );
    },

    canUseRedirectRoutes: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("redirect_routes")
      );
    },

    canUseBrandedDomains: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_branded_domains")
      );
    },

    canPurchaseBrandedDomains: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("purchase_branded_domains")
      );
    },

    canAddBrandedDomains: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("add_branded_domains")
      );
    },

    canAddVanitySubdomains: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("add_vanity_subdomains")
      );
    },

    canUseCustomAlias: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_custom_alias")
      );
    },

    canUseTags: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_tags")
      );
    },

    canUseApi: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_api")
      );
    },

    canUseDomainRootRedirect: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("domain_root_redirect")
      );
    },

    canUseDomain404Redirect: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("domain_404_redirect")
      );
    },

    supportTeams: (state, getters) => {
      return !!(
        getters.user &&
        getters.user.features &&
        getters.user.features.includes("support_teams")
      );
    },

    canCreateTinyUrl: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("create_tiny_url")
      );
    },

    canUpdateTinyUrl: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("update_tiny_url")
      );
    },

    canUseBulkRequests: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_bulk")
      );
    },

    canUseAnalytics: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_analytics")
      );
    },

    canUseOverages: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("use_overages")
      );
    },

    canManageExpiration: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("manage_expiration")
      );
    },

    canBulkCreateTinyUrl: (state, getters) => {
      return getters.canCreateTinyUrl && getters.canUseBulkRequests;
    },

    canArchiveTinyUrl: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("archive_tiny_url")
      );
    },

    canDeleteTinyUrl: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("delete_tiny_url")
      );
    },

    canChangeLongUrl: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("change_long_url")
      );
    },

    canShareStats: (state, getters) => {
      const billable = getters.teamMode ? getters.team : getters.user;

      return !!(
        billable &&
        billable.features &&
        billable.features.includes("share_analytics")
      );
    },

    userStatusNoAffiliate: (state, getters) => {
      return !!(
        getters.user &&
        getters.user.status &&
        (getters.user.status & 0x04) !== 0
      );
    },
  },
};
